// pages/Dashboard.jsx
import TrendingBooks from "../../components/home/TrendingBooks";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <TrendingBooks />
    </HomeLayout>
  );
}
